<template>
  <div>
    <div class="mt-2">
      <naj-search-box
        v-if="isIncomingRequestTab"
        :type-id="formFieldType.number"
        :placeholder="local.home.tabCommon.filterWithCaseCode"
        :search.sync="searchQuery.caseCode"
        @filterDataClicked="filterData()"
        @showFilterClicked="toggleFilter()"
      ></naj-search-box>
      <naj-search-box
        v-else
        :type-id="formFieldType.number"
        :placeholder="local.home.tabCommon.filterWithRequestCode"
        :search.sync="searchQuery.requestCode"
        @filterDataClicked="filterData()"
        @showFilterClicked="toggleFilter()"
      ></naj-search-box>
    </div>
    <div v-if="hasFilter" class="filter-row-wrapper d-flex mt-3">
      <div class="col-12">
        <template v-for="filter in filters">
          <span v-if="searchQuery[filter.name]" :key="filter.name" class="ma-1">
            <v-chip
              :key="filter.name"
              :input-value="searchQuery[filter.name]"
              color="#F7FBFB"
              close
              outlined
              @click:close="
                searchQuery[filter.name] = null;
                filterData();
              "
            >
              <strong class="text-primary">{{
                filter.label + ':' + (searchQuery[filter.name + 'DisplayName'] || searchQuery[filter.name])
              }}</strong>
            </v-chip>
          </span>
        </template>
      </div>
    </div>
    <div class="mt-7 row tab-wrapper">
      <div class="col-2 tabs-box">
        <v-tabs v-model="tab" vertical hide-slider>
          <template v-for="tabButton in requestTabs.filter(t => t.isEnabled)">
            <v-tab
              :key="tabButton.href"
              :disabled="tabButton.isDisabled"
              :href="tabButton.href"
              class="tab-button"
              active-class="tab-active"
            >
              <v-icon left class="tab-button-icon">
                {{ tabButton.icon }}
              </v-icon>
              <span class="mr-1"> {{ tabButton.title }}</span>
            </v-tab>
          </template>
        </v-tabs>
      </div>
      <div class="col-10" style="margin-top: -52px;">
        <v-tabs-items v-model="tab">
          <v-tab-item value="tab-1">
            <div>
              <v-row class="mt-7">
                <v-col :cols="showFilter ? 8 : 12">
                  <naj-item-table
                    :data-items="data.list"
                    :headers="requestHeaders"
                    :pagination="pagination"
                    :loading="loading"
                    :items-per-page="20"
                    :server-items-length="pagination.totalCount"
                    class="request-item-table"
                    @update:page="onPageChange"
                  >
                    <template slot="requestCode" slot-scope="{ item }">
                      <div class="info-item-details-title">
                        {{ local.home.tabCommon.requestCode }}
                      </div>
                      <div class="info-item-details-value">
                        {{ item.requestCode }}
                      </div>
                    </template>

                    <template v-if="item.requestStatusId == requestStatus.NotCompleted" slot="action" slot-scope="{ item }">
                      <div class="mx-4">
                        <v-menu offset-y>
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on">
                              mdi-dots-vertical
                            </v-icon>
                          </template>
                          <v-list>
                            <v-list-item>
                              <v-list-item-title>
                                <naj-button text type="button" size="small" @click="showRequestInCompleteReasons(item)">
                                  {{ local.common.inCompleteReasons }}
                                </naj-button>
                              </v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </div>
                    </template>
                  </naj-item-table>
                </v-col>
                <v-col v-if="showFilter" cols="4">
                  <v-card color="pa-3">
                    <v-row>
                      <v-col class="pt-0">
                        <div class="text-left">
                          <v-icon class="icon" @click="toggleFilter()">
                            mdi-close
                          </v-icon>
                        </div>
                        <div class="text-h4 font-weight-bold">
                          {{ local.common.filter }}
                        </div>
                      </v-col>
                      <v-col v-for="filter in filters" :key="filter.name" cols="12">
                        <naj-input
                          :type-id="filter.typeId"
                          :label="filter.label"
                          :value.sync="searchQuery[filter.name]"
                          :value-name.sync="searchQuery[filter.name + 'DisplayName']"
                          :items="filter.items"
                          item-text="name"
                          item-value="id"
                        ></naj-input>
                      </v-col>

                      <v-col cols="12" class="text-center">
                        <naj-button :loading="loading" @click="filterData()">
                          {{ local.common.filter }}
                        </naj-button>

                        <naj-button outlined @click="toggleFilter()">
                          {{ local.common.close }}
                        </naj-button>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-tab-item>
          <v-tab-item value="tab-2">
            <div>
              <v-row class="mt-7">
                <v-col :cols="showFilter ? 8 : 12">
                  <naj-item-table
                    :data-items="data.list"
                    :headers="LegacyCaseRequestHeaders"
                    :pagination="pagination"
                    :loading="loading"
                    :items-per-page="20"
                    :server-items-length="pagination.totalCount"
                    class="request-item-table"
                    @update:page="onPageChange"
                  >
                    <template slot="requestCode" slot-scope="{ item }">
                      <div class="info-item-details-title">
                        {{ local.home.tabCommon.requestCode }}
                      </div>
                      <div class="info-item-details-value">
                        {{ item.requestCode }}
                      </div>
                    </template>
                  </naj-item-table>
                </v-col>
                <v-col v-if="showFilter" cols="4">
                  <v-card color="pa-3">
                    <v-row>
                      <v-col class="pt-0">
                        <div class="text-left">
                          <v-icon class="icon" @click="toggleFilter()">
                            mdi-close
                          </v-icon>
                        </div>
                        <div class="text-h4 font-weight-bold">
                          {{ local.common.filter }}
                        </div>
                      </v-col>
                      <v-col v-for="filter in filters" :key="filter.name" cols="12">
                        <naj-input
                          :type-id="filter.typeId"
                          :label="filter.label"
                          :value.sync="searchQuery[filter.name]"
                          :value-name.sync="searchQuery[filter.name + 'DisplayName']"
                          :items="filter.items"
                          item-text="name"
                          item-value="id"
                        ></naj-input>
                      </v-col>

                      <v-col cols="12" class="text-center">
                        <naj-button :loading="loading" @click="filterData()">
                          {{ local.common.filter }}
                        </naj-button>

                        <naj-button outlined @click="toggleFilter()">
                          {{ local.common.close }}
                        </naj-button>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-tab-item>
          <v-tab-item value="tab-3">
            <div>
              <v-row class="mt-7">
                <v-col :cols="showFilter ? 8 : 12">
                  <naj-alert type="information">
                    <template slot="content">
                      {{ local.home.tabCommon.incomingRequestsAlert }}
                    </template>
                  </naj-alert>
                  <naj-item-table
                    :data-items="data.list"
                    :headers="incomingRequestHeaders"
                    :pagination="pagination"
                    :loading="loading"
                    :items-per-page="pagination.pageSize"
                    :server-items-length="pagination.totalCount"
                    class="request-item-table"
                    @update:page="onPageChange"
                  >
                    <template slot="caseCode" slot-scope="{ item }">
                      <div class="info-item-details-title">
                        {{ local.home.tabCommon.caseCode }}
                      </div>
                      <div class="info-item-details-value">
                        {{ item.caseCode }}
                      </div>
                    </template>
                  </naj-item-table>
                </v-col>
                <v-col v-if="showFilter" cols="4">
                  <v-card color="pa-3">
                    <v-row>
                      <v-col class="pt-0">
                        <div class="text-left">
                          <v-icon class="icon" @click="toggleFilter()">
                            mdi-close
                          </v-icon>
                        </div>
                        <div class="text-h4 font-weight-bold">
                          {{ local.common.filter }}
                        </div>
                      </v-col>
                      <v-col v-for="filter in filters" :key="filter.name" cols="12">
                        <naj-input
                          :type-id="filter.typeId"
                          :label="filter.label"
                          :value.sync="searchQuery[filter.name]"
                          :value-name.sync="searchQuery[filter.name + 'DisplayName']"
                          :items="filter.items"
                          item-text="name"
                          item-value="id"
                        ></naj-input>
                      </v-col>

                      <v-col cols="12" class="text-center">
                        <naj-button :loading="loading" @click="filterData()">
                          {{ local.common.filter }}
                        </naj-button>

                        <naj-button outlined @click="toggleFilter()">
                          {{ local.common.close }}
                        </naj-button>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </div>

    <naj-confirmation
      :show-modal="requestInCompleteReasonsModal"
      :max-width="750"
      :is-persistent="false"
      :title="local.common.inCompleteReasons"
      :close-btn-label="local.common.close"
      @cancel="hideRequestInCompleteReasons"
    >
      <template slot="message-content">
        <v-row>
          <v-col>
            <naj-alert type="information">
              <template v-if="selectedRequest" slot="content">
                <span v-if="selectedRequest.notes"> {{ selectedRequest.notes }}</span>
                <span v-else> {{ local.common.noReasonsToDisplay }} </span>
              </template>
            </naj-alert>
          </v-col>
        </v-row>
      </template>
    </naj-confirmation>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapLawsuitActions } = createNamespacedHelpers('LawsuitModule');
import { toHijriDate } from '@/helpers/utils';
import { RequestTypesNames, RequestTypesIds, requestStatus } from '@/helpers/enum';

const { mapState: mapLUTState, mapActions: mapLUTActions } = createNamespacedHelpers('LookupsModule');
import { userType } from '@/helpers/enum';
const { mapState: mapGlobalState, mapActions: mapGlobalActions } = createNamespacedHelpers('GlobalModule');

export default {
  name: 'RequestsTab',
  components: {},
  props: {
    itemsPerPage: {
      default: 10,
      type: Number,
      required: false,
    },
    noDataText: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      tab: 'tab-1', // default to first tab
      showLegacyCaseRequests: false,
      requestTabs: [
        {
          href: '#tab-1',
          icon: 'mdi mdi-archive',
          title: this.local.home.tabs.outgoingRequests,
          isEnabled: true,
          isDisabled: false,
        },
        {
          href: '#tab-2',
          icon: 'mdi mdi-archive-search-outline',
          title: this.local.home.tabs.legacyCaseRequests,
          isEnabled: true,
          isDisabled: false,
        },
        {
          href: '#tab-3',
          icon: 'mdi mdi-inbox-arrow-down',
          title: this.local.home.tabs.incomingRequests,
          isEnabled: false,
          isDisabled: false,
        },
      ],
      searchQuery: {
        courtId: null,
        fromRequestDate: null,
        toRequestDate: null,
        requestTypeId: null,
        requestStatusId: null,
        requestCode: null,
        caseCode: null,
      },
      RequestTypesNames,
      requestStatus,
      selectedRequest: {},
      requestInCompleteReasonsModal: false,
      loading: false,
      data: { list: [] },
      showFilter: false,
      pagination: {
        pageSize: 10,
        pageIndex: 0,
        totalCount: 0,
        totalPages: 0,
        hasPreviousPage: false,
        hasNextPage: false,
      },
      requestHeaders: [
        {
          value: 'requestCode',
          text: this.local.home.tabCommon.requestCode,
          isCustomTemplate: true,
          to: (item) => {
            const requestType = RequestTypesIds[item.requestTypeId];
            if (requestType) {
              if (requestType === 'reconsideration-from-non-case-party') {
                return {
                  name: 'view-reconsideration-from-non-case-party',
                  params: {
                    requestType: requestType,
                    requestObjectKey: item.objectKey,
                  },
                  query: { isPega: String(item.isPega) },
                };
              } else {
                return {
                  name: 'view-case-related-request',
                  params: {
                    requestType: requestType,
                    requestObjectKey: item.objectKey,
                  },
                  query: { isPega: String(item.isPega) },
                };
              }
            }
            return null;
          },
          class: 'requestCode-header',
        },
        {
          value: 'caseCode',
          text: this.local.home.tabCommon.caseCode,
          to: (item) => {
            if (this.notAllowedRequestTypes.indexOf(item.requestTypeId) == -1) {
              return {
                name: 'case-file',
                params: {
                  caseObjectKey: item.caseObjectKey,
                  isPega: String(item.isPega),
                },
              };
            }
            return null;
          },
        },
        {
          value: 'requestDate',
          text: this.local.home.tabCommon.requestDate,
          formatter: toHijriDate,
        },
        {
          value: 'requestTypeName',
          text: this.local.home.tabCommon.requestType,
        },
        {
          value: 'applicantCasePartyName',
          text: this.local.home.tabCommon.requesterName,
        },
        {
          value: 'requestStatusName',
          text: this.local.home.tabCommon.status,
        },
        {
          value: 'action',
          class: 'action-item justify-content-center',
          isCustomTemplate: true,
        },
      ],
      LegacyCaseRequestHeaders: [
        {
          value: 'requestCode',
          text: this.local.home.tabCommon.requestCode,
          class: 'requestCode-header',
        },
        {
          value: 'requestDate',
          text: this.local.home.tabCommon.requestDate,
          formatter: toHijriDate,
        },
        {
          value: 'caseCode',
          text: this.local.home.tabCommon.caseCode,
        },
        {
          value: 'judgementCode',
          text: this.local.home.tabCommon.judgementCode,
        },
        {
          value: 'courtName',
          text: this.local.home.tabCommon.courtName,
        },
        {
          value: 'requestStatusName',
          text: this.local.home.tabCommon.status,
        },
        {
          value: 'action',
          class: 'action-item justify-content-center',
          isCustomTemplate: true,
        },
      ],
      incomingRequestHeaders: [
        {
          value: 'caseCode',
          text: this.local.home.tabCommon.caseCode,
          isCustomTemplate: true,
          to: (item) => {
            return {
              name: 'view-incoming-request',
              params: { requestObjectKey: item.objectKey },
              query: { isPega: 'true' },
            };
          },
          class: 'requestCode-header',
        },
        {
          value: 'courtName',
          text: this.local.home.tabCommon.courtName,
        },
        {
          value: 'creationDate',
          text: this.local.home.tabCommon.requestDate,
          formatter: toHijriDate,
        },
        {
          value: 'name',
          text: this.local.home.tabCommon.requestType,
        },
      ],
    };
  },
  computed: {
    ...mapLUTState(['courts', 'portalRequestStatus', 'caseRequestTypes', 'incomingRequestTypes']),
    ...mapGlobalState(['userInfo']),
    isNajizCitizen() {
      return this.userInfo && this.userInfo.userType === userType.najizCitizen;
    },
    isLegacyCaseRequestTab() {
      return this.tab === 'tab-2';
    },
    isIncomingRequestTab() {
      return this.tab === 'tab-3';
    },
    hasFilter() {
      return (
        this.searchQuery.courtId ||
        this.searchQuery.fromRequestDate ||
        this.searchQuery.toRequestDate ||
        this.searchQuery.requestTypeId ||
        this.searchQuery.requestStatusId
      );
    },
    filters() {
      const filterableRequestStatus = this.isLegacyCaseRequestTab
        ? this.portalRequestStatus.filter((obj) => [2, 5, 6].includes(obj.id))
        : this.portalRequestStatus;

      const filterableRequestTypes = this.isIncomingRequestTab
        ? this.mapFilterItem('requestTypeId', 'requestType', 'selectbox', this.incomingRequestTypes)
        : this.mapFilterItem('requestTypeId', 'requestType', 'selectbox', this.caseRequestTypes);

      const filters = [
        this.mapFilterItem('courtId', 'court', 'selectbox', this.courts),
        this.mapFilterItem('fromRequestDate', 'fromDate', 'date'),
        this.mapFilterItem('toRequestDate', 'toDate', 'date'),
      ];

      if (!this.isLegacyCaseRequestTab) {
        filters.push(filterableRequestTypes);
      }

      if (!this.isIncomingRequestTab) {
        filters.push(this.mapFilterItem('requestStatusId', 'requestStatus', 'selectbox', filterableRequestStatus));
      }
      return filters;
    },
    computedSearchQuery() {
      return Object.assign({}, this.searchQuery);
    },
    notAllowedRequestTypes() {
      return [
        RequestTypesNames.intervenor.id,
        RequestTypesNames.addRepresentative.id,
        RequestTypesNames.joinder.id,
        RequestTypesNames.reconsiderationFromNonCaseParty.id,
      ];
    },
  },
  watch: {
    computedSearchQuery: {
      deep: true,
      handler(newValue, oldValue) {
        const oldValueString = JSON.stringify({
          ...oldValue,
          requestCode: null,
        });
        const newValueString = JSON.stringify({
          ...newValue,
          requestCode: null,
        });
        const isChanged = oldValueString != newValueString;
        if (isChanged) {
          this.filterData();
        }
      },
    },
    tab() {
      // reset pagination and filters whenever tab changes
      this.$set(this, 'data', {});
      this.$set(this.data, 'list', []);
      this.resetPagination();
      this.resetFilters();
      this.showFilter = false; // close filter panel when switching tabs
      this.loadData();
    },
  },
  mounted() {
    this.showLegacyCaseRequests = true; // always show tabs
    this.init();
  },
  methods: {
    ...mapLUTActions(['getCourts', 'getPortalRequestStatus', 'getCaseRequestTypes', 'getIncomingRequestsTypes']),
    resetPagination() {
      this.pagination = {
        pageSize: 10,
        pageIndex: 0,
        totalCount: 0,
        totalPages: 0,
        hasPreviousPage: false,
        hasNextPage: false,
      };
    },
    resetFilters() {
      // reset search query filters but keep the requestCode
      const requestCode = this.searchQuery.requestCode;
      this.searchQuery = {
        courtId: null,
        fromRequestDate: null,
        toRequestDate: null,
        requestTypeId: null,
        requestStatusId: null,
        requestCode: requestCode, // preserve search box value
      };
    },
    mapFilterItem(name, key, typeId, items = []) {
      return {
        name: name,
        label: this.local.home.filter?.[key] || key,
        typeId: this.formFieldType[typeId],
        items,
      };
    },
    toggleFilter() {
      this.showFilter = !this.showFilter;
    },
    ...mapLawsuitActions(['getMyRequests', 'getMyLegacyCaseDigitizationRequest', 'getIncomingRequests', 'userHasIncomingRequests']),
    ...mapGlobalActions(['getUserInfo']),
    init() {
      this.getUserInfo();
      this.loadData();
      this.getCourts();
      this.getPortalRequestStatus();
      this.getCaseRequestTypes();
      debugger;
      if (this.isNajizCitizen) {
        this.userHasIncomingRequests()
          .then(({ data }) => {
            if (data) {
              this.requestTabs[2].isEnabled = true;
              this.requestTabs[2].isDisabled = false;
              this.getIncomingRequestsTypes();
            } else {
              this.requestTabs[2].isEnabled = false;
              this.requestTabs[2].isDisabled = true;
            }
          })
          .catch(() => {
            this.requestTabs[2].isEnabled = false;
            this.requestTabs[2].isDisabled = true;
          });
      }
    },
    loadData() {
      this.loading = true;
      this.$set(this, 'data', {});
      this.$set(this.data, 'list', []);
      let requestPromise;
      if (this.isLegacyCaseRequestTab) {
        requestPromise = this.getMyLegacyCaseDigitizationRequest({
          ...this.searchQuery,
          ...this.pagination,
        });
      } else if (this.isIncomingRequestTab) {
        requestPromise = this.getIncomingRequests({
          ...this.searchQuery,
          ...this.pagination,
        });
      } else {
        requestPromise = this.getMyRequests({
          ...this.searchQuery,
          ...this.pagination,
        });
      }
      requestPromise
        .then(({ data }) => {
          this.loading = false;
          this.data = data;
          this.pagination = {
            pageIndex: data.pageIndex,
            pageSize: data.pageSize,
            totalCount: data.totalCount,
            totalPages: data.totalPages,
            hasPreviousPage: data.hasPreviousPage,
            hasNextPage: data.hasNextPage,
          };
        })
        .finally(() => {
          this.loading = false;
          this.$emit('updateTabCount', this.pagination.totalCount);
        });
    },
    onPageChange(pageIndex) {
      this.pagination.pageIndex = pageIndex - 1;
      this.loadData();
    },
    filterData() {
      this.pagination.pageIndex = 0;
      this.loadData();
    },
    showRequestInCompleteReasons(request) {
      this.selectedRequest = request;
      this.requestInCompleteReasonsModal = true;
    },
    hideRequestInCompleteReasons() {
      this.requestInCompleteReasonsModal = false;
      this.selectedRequest = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.tabs-box {
  padding: 0;
  background: #faf9f4;

  .tab-button {
    font: normal normal normal 16px/24px Almarai;
    justify-content: right;

    &.tab-active {
      font-weight: bold;
      color: var(--app-primary-color);
    }
  }
}

.v-tab {
  background: #faf9f4 !important;
}

::v-deep .List__empty {
  margin-top: 0px !important;
}

::v-deep .info-item-box .info-item-details:nth-child(1) {
  background: var(--app-light-secondary-color) 0% 0% no-repeat padding-box;
}

.filter-row-wrapper {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 10px 30px #d1d5df80;
}

::v-deep .info-item-details.requestCode-header {
  .info-item-details-value {
    font-size: 24px;
  }
}

.tab-active {
  font-weight: bold;
  color: #02ad68 !important;
  border-left: 4px solid #02ad68;

  .tab-button-icon {
    color: #02ad68 !important;
  }
}

.info-item-box {
  display: flex;
  justify-content: space-between;
  flex: 1;
  height: 100%;
}

.info-item-details-title {
  font-size: 14px;
}

.info-item-details-value {
  font-weight: bold;
  font-size: 16px;
}

.request-item-table {
  padding: 13px;
}

.tab-wrapper {
  margin-left: -23px;
  margin-right: 0px;
}
</style>
